module.exports = __webpack_public_path__ + "static/media/FT-Prototipo.1be4a975.png";